export const about = `
Parafia Świętej Urszuli Ledóchowskiej w Częstochowie – rzymskokatolicka parafia, 
położona w dekanacie Częstochowa – św. Antoniego z Padwy, 
archidiecezji częstochowskiej w Częstochowie, w dzielnicy Wrzosowiak. 
Erygowana w 1985 roku.
`
export const history = ` 
W 1981 roku ks. Franciszek Rąpała, proboszcz parafii św. Józefa kupił posesję z budynkiem mieszkalnym przy ul. Sportowej 80 w Częstochowie. 
17 października 1982 roku w pomieszczeniu zaadaptowanym na kaplicę została odprawiona pierwsza Msza Święta. 22 sierpnia 1983 roku ustanowiono wikariat terenowy. 
Wikariuszem, a później pierwszym proboszczem został ks. Jerzy Sojczyński. Parafia została erygowana przez Arcybiskupa Stanisława Nowaka dnia 15 lutego 1985 roku. 
Pierwszy Proboszcz Zakupił plac pod budowę kościoła i plebanii przy ulicy Władysława Orkana 60/62. 
Kamień węgielny pod budowę świątyni został poświęcony przez Jana Pawła II dnia 12 czerwca 1987 roku. 
We wrześniu tego roku rozpoczęto budowę kościoła. Dzieło ukończenia budowy i jej wyposażenia podjął od 1997 proboszcz ks. Gabriel Biskup. 
Uroczystej konsekracji świątyni dokonał Arcybiskup Wacław Depo dnia 29 maja 2022 roku.
`

export const patronImage = "./assets/urszula_logo.png"
export const fanpage = "https://www.facebook.com/parafiaswurszuli"

export const peregrination = `
Matka Urszula Ledóchowska odeszła do Pana 29 maja 1939 roku w Rzymie. Spoczęła początkowo na cmentarzu Campo Verano. Po dwudziestu latach, 22 kwietnia 1959 roku, dokonano ekshumacji jej ciała, które 2 grudnia tego samego roku przeniesiono do grobowca w kaplicy Domu Generalnego Sióstr Urszulanek Serca Jezusa Konającego przy via del Casaletto w Rzymie.

Ciało błogosławionej Urszuli spoczywało tam do października 1988 roku. Podczas otwarcia trumien stwierdzono, że zachowało się w nienaruszonym stanie.

W pięćdziesiątą rocznicę śmierci Matki Urszuli, w dniach od 11 do 29 maja 1989 roku, jej relikwie zostały przewiezione z Rzymu do Pniew – do Domu Macierzystego Zgromadzenia Sióstr Urszulanek SJK. W drodze nawiedziły miejsca szczególnie związane z życiem i posługą Matki Urszuli: włoską Brescię, a także austriacki Loosdorf, gdzie przyszła na świat. Najdłużej trwała peregrynacja po Polsce – relikwie wędrowały z południa kraju, z Zakopanego, przez Częstochowę, Łódź, Warszawę i Poznań, by 28 maja 1989 roku dotrzeć do Pniew. Dwa dni później, 30 maja, zostały uroczyście złożone w sarkofagu w bocznej kaplicy Domu Macierzystego Sióstr Urszulanek Serca Jezusa Konającego.
`

export const parishPeregrination = `
W naszej Parafii relikwie Matki Urszuli przebywały w dniach 21-22 maja. Wówczas odbyła się uroczysta Masza Święta z udziałem Sióstr Urszulanek.
`
export const priests = [
  {
    priest: "Paweł Bekus",
    start: 1999,
  },
  {
    priest: "Grzegorz Nowicki",
    start: 1999,
  },
  {
    priest: "Arkadiusz Bolesław Gudowski",
    start: 2000,
  },
  {
    priest: "Marek Michał Woldan",
    start: 2000,
  },
  {
    priest: "Przemysław Palmowski",
    start: 2001,
  },
]
export const parishPriests = [
  {
    priest: "Jerzy Sojczyński",
    start: 1985,
    end: 1997,
    alive: false
  },
  {
    priest: "Gabriel Biskup",
    start: 1997,
    end: 2023,
  },
  {
    priest: "Mikołaj Węgrzyn",
    start: 2023,
  },
]
export const vicars = [
  {
    priest: "Błażej Małolepszy",
    start: 2026
  },
  {
    priest: "Piotr Placek",
    start: 2020
  },
  {
    priest: "Marian Kozłowski",
    start: 1991,
    end: 1995,
  },
  {
    priest: "Krzysztof Mońka",
    start: 1988,
    end: 1990,
    start2: 2008,
    end2: 2014
  },
  {
    priest: "Grzegorz Dymek",
    start: 1993,
    end: 1994,
    alive: false
  },
  {
    priest: "Wojciech Torchała",
    start: 1997,
    end: null,
    alive: false
  },
  {
    priest: "Piotr Kaczmarek",
    start: 2010,
    end: 2014,
  },
  {
    priest: "Paweł Gancarek",
    start: 2014,
    end: null,
  },
  {
    priest: "Jacek Gancarek",
    start: 1997,
    end: null,
  },
  {
    priest: "Andrzej Chałupka",
    start: 2005,
    end: null,
  },
  {
    priest: "Maciej Oset",
    start: 2001,
    end: null,
  },
  {
    priest: "Maciej Poniewiera",
    start: 2001,
    end: 2005,
    alive: false
  },
  {
    priest: "Sławomir Ostojski",
    start: 2008,
    end: null,
  },
  {
    priest: "Jan Lisiecki",
    start: 1995,
    end: null,
  },
  {
    priest: "Stanisław Wybański",
    start: 1987,
    end: 1989,
  },
  {
    priest: "Wojciech Krasowki",
    start: 1987,
    end: null,
  },
  {
    priest: "Jan Dyliński",
    start: 1990,
    end: null,
  },
  {
    priest: "Stanisław Lech",
    start: 1991,
    end: 1993,
  },
  {
    priest: "Marek Łakomy",
    start: 1991,
    end: 1993,
  },
  {
    priest: "Antoni Góra",
    start: 1993,
    end: 1994,
  },
  {
    priest: "Leszek Łukowski",
    start: 1994,
    end: null,
  },
  {
    priest: "Sławomir Kondziora",
    start: 1996,
    end: null,
  },
  {
    priest: "Sylwester Tronina",
    start: 1996,
    end: 1997,
  },
  {
    priest: "Paweł Wolnicki",
    start: 1994,
    end: null,
  },
  {
    priest: "Józef Zawiślak",
    start: 1999,
    end: null,
  },
  {
    priest: "Artur Stopikowski",
    start: 2001,
    end: null,
  },
  {
    priest: "Tomasz Słabiak",
    start: 2006,
    end: null,
  },
  
]
export const parishHistory = [
  {
    year: 1981,
    description: "Ks. Franciszek Rąpała, proboszcz parafii św. Józefa, zakupił posesję z budynkiem mieszkalnym przy ul. Sportowej 80 w Częstochowie."
  },
  {
    year: 1982,
    description: "17 października w zaadaptowanym pomieszczeniu, przystosowanym na kaplicę, została odprawiona pierwsza Msza Święta."
  },
  {
    year: 1983,
    description: "22 sierpnia ustanowiono wikariat terenowy. Wikariuszem, a później pierwszym proboszczem, został ks. Jerzy Sojczyński."
  },
  {
    year: 1985,
    description: "Parafia została oficjalnie erygowana przez Arcybiskupa Stanisława Nowaka dnia 29 stycznia."
  },
  {
    year: 1987,
    description: "Pierwszy proboszcz zakupił plac pod budowę kościoła i plebanii przy ul. Władysława Orkana 60/62. Kamień węgielny został poświęcony przez Jana Pawła II 12 czerwca. We wrześniu rozpoczęto budowę świątyni."
  },
  {
    year: 1997,
    description: "Dzieło ukończenia budowy oraz wyposażenia kościoła kontynuował proboszcz ks. Gabriel Biskup."
  },
  {
    year: 2022,
    description: "Uroczystej konsekracji kościoła dokonał Arcybiskup Wacław Depo 29 maja."
  },
  {
    year: 2023,
    description: "Dnia 1 lipca proboszczem Parafii zostaje ks. Mikołaj Węgrzyn."
  },

];

export const peregrinationImages = [
  "./assets/peregrynacja3.jpg",
  "./assets/peregrynacja1.jpg",
  "./assets/peregrynacja2.jpg"
];